import * as React from "react";

export function BroadStateCenterValue({
    hasAveragePercent,
    displayAveragePercent,
    color,
}: {
    hasAveragePercent: boolean;
    displayAveragePercent: number;
    color: string;
}) {
    const value = displayAveragePercent.toString();
    const percentStyle: React.CSSProperties = {
        position: "absolute",
        left: "calc(100% + 0.03em)",
        top: "-0.06em",
        fontSize: "0.8em",
        opacity: 0.72,
    };

    return (
        <div
            style={{
                position: "absolute",
                left: "50%",
                top: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 2,
            }}
        >
            {hasAveragePercent ? (
                <span
                    style={{
                        position: "relative",
                        display: "inline-block",
                        transform: "translateX(-1.5px)",
                        color: "#b8f5a1",
                        fontFamily: '"IM Fell French Canon SC", serif',
                        fontSize: "19px",
                        fontWeight: 700,
                        fontVariantNumeric: "lining-nums tabular-nums",
                        letterSpacing: "-0.06em",
                        lineHeight: 1,
                        textShadow: `0 1px 1px #061006, 0 0 2px ${color}, 0 0 5px ${color}, 0 0 9px ${color}`,
                    }}
                >
                    <span
                        aria-hidden="true"
                        style={{
                            position: "absolute",
                            inset: 0,
                            color,
                            filter: "blur(2px)",
                            opacity: 0.32,
                        }}
                    >
                        {value}
                        <span style={percentStyle}>%</span>
                    </span>
                    <span style={{ position: "relative" }}>
                        {value}
                        <span style={percentStyle}>%</span>
                    </span>
                </span>
            ) : (
                <span
                    aria-label="No broad state data"
                    title="No broad state data"
                    style={{
                        display: "inline-block",
                        fontSize: "28px",
                        lineHeight: 1,
                        color: "#b0803d",
                        textShadow: "0 0 8px rgba(176, 128, 61, 0.55)",
                    }}
                >
                    ⟳
                </span>
            )}
        </div>
    );
}
